"use client";

import BulkOrders from "@/components/desktop/BulkOrders";
import TourGuide from "@/components/home/TourGuide";
import MobileBulkOrders from "@/components/mobile/MobileBulkOrders";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useDevice } from "@/hooks/useDevice";

const Page: React.FC = () => {
  const { firstLogin } = useAppSelector((state) => state.auth);
  const isMobile = useDevice();

  return (
    <>
      {firstLogin && <TourGuide />}
      {isMobile ? <MobileBulkOrders /> : <BulkOrders />}
    </>
  );
};

export default Page;
